import React, { useEffect, useCallback, useState } from 'react';
import StyledButton from '../../../shared/components/styledButton/styledButton.jsx';

import i18n from '../../../utils/i18n.js';
import { withTranslation } from 'react-i18next';
import ContactInfo from '../components/contactInfo/contactInfo.jsx';
import ACTIONS from '../../../redux/action.js';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { gdprLabelSF } from '../data/regFlowText.js';
import axios from '../../../shared/axios/axiosProxy.js';
import { Switch } from '@mui/material';
import { CleaveInput } from '../../../shared/components/formattedInput/formattedInputs.jsx';
import { TextField } from '@mui/material';
import { createCalComUrl, navigateToUrl } from '../../utils/companyUtils.js';

const RegContactForm = ({ handleBack }) => {
	const [nameError, setNameError] = useState(false);
	const [emailError, setEmailError] = useState(false);
	const [companyLegalName, setCompanyLegalName] = useState('');
	const [legalAddress, setLegalAddress] = useState('');
	const [companyTaxnumber, setCompanyTaxnumber] = useState('');
	const [phoneError, setPhoneError] = useState(false);
	const [gdprError, setGdprError] = useState(false);
	const [isReqSent, setIsReqSent] = useState(false);
	const [isCardPayment, setIsCardPayment] = useState();
	const [isCompany, setIsCompany] = useState(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const companyStore = useSelector((state) => state.company_store);

	const dataLayerUpdate = (isCardPayment) => {
		window.dataLayer.push({
			event: 'sf_step_reg_request_sent',
			event_category: 'regflow',
		});
		isCardPayment &&
			window.dataLayer.push({
				event: 'sf_step_reg_card_payment_started',
				event_category: 'regflow',
			});
	};

	useEffect(() => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'reqFromBupa',
				data: false,
				stateObject: 'company_store',
			})
		);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'callbacksource',
				data: 'regrequest',
				stateObject: 'company_store',
			})
		);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'leadtype',
				data: 'REG',
				stateObject: 'company_store',
			})
		);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'isCallBackReq',
				data: false,
				stateObject: 'company_store',
			})
		);
	}, []);

	const validateEmail = useCallback(() => {
		const validEmailRegex = RegExp(
			// eslint-disable-next-line no-useless-escape
			/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
		);
		return validEmailRegex.test(companyStore.email);
	}, [companyStore.email]);

	const validateName = useCallback(() => {
		if (companyStore.companyctcname.trim().length > 0) {
			return true;
		}
		return false;
	}, [companyStore.companyctcname]);

	const validatePhone = useCallback(() => {
		if (companyStore.companyPhone.length >= 8) {
			return true;
		}
		return false;
	}, [companyStore.companyPhone]);

	useEffect(() => {
		if (emailError && validateEmail()) {
			setEmailError(false);
		}
		if (gdprError && companyStore.gdpr) {
			setGdprError(false);
		}
		if (phoneError && validatePhone()) {
			setPhoneError(false);
		}
		if (nameError && validateName()) {
			setNameError(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		companyStore.gdpr,
		validateEmail,
		companyStore,
		emailError,
		gdprError,
		phoneError,
		nameError,
		validateName,
		validatePhone,
	]);

	const requestCallBack = async (isCardPayment) => {
		let data = Object.assign({}, companyStore);

		await axios
			.post(
				`/api/aspreq/requestcallback/new`,
				{
					...data,
					isCardPaymentStarted: isCardPayment,
				},
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			)
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
				const reqId = response.data.result._id;
				if (reqId) {
					dispatch(
						ACTIONS.addCompanyInfo({
							id: 'reqID',
							data: reqId,
							stateObject: 'company_store',
						})
					);
				}
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response?.data || error.message);
			});
	};

	useEffect(() => {
		if (isCardPayment != null && companyStore.reqID) {
			isCardPayment
				? navigate('/company/request/reg/checkout')
				: navigateToUrl(
						createCalComUrl({
							reqId: companyStore.reqID,
							compCtcName: companyStore.companyctcname,
							compEmail: companyStore.email,
							compPhone: companyStore.companyPhone,
						})
				  );
		}
	}, [isCardPayment, companyStore.reqID]);

	const submitButtonDisabled = () => {
		return (
			(isCompany &&
				(!companyStore.companylegalname ||
					companyStore.companylegalname.trim().length === 0 ||
					!companyStore.companytaxnumber ||
					companyStore.companytaxnumber.trim().length === 0)) ||
			!companyStore.legaladdress ||
			companyStore.legaladdress.trim().length === 0 ||
			!companyStore.companyctcname ||
			companyStore.companyctcname.length === 0 ||
			!companyStore.companyPhone ||
			companyStore.companyPhone.length < 10 ||
			!companyStore.email ||
			companyStore.email.length === 0 ||
			!validateEmail() ||
			!companyStore.gdpr
		);
	};

	const handleSubmitButton = (isCardPayment) => {
		dataLayerUpdate(isCardPayment);
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'submitted',
				data: true,
				stateObject: 'company_store',
			})
		);
		requestCallBack(isCardPayment);
		setIsReqSent(true);
		setIsCardPayment(isCardPayment);
	};

	return (
		<div>
			<div className="stepContainer">
				<div>
					<ContactInfo />
					<div>
						<FormControlLabel
							key={'accounting'}
							control={
								<Checkbox
									id="accounting"
									name="checked"
									checked={companyStore.accounting}
									onChange={(event) => {
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.checked,
												stateObject: 'company_store',
											})
										);
									}}
									color="primary"
									/*    disabled={this.state.submitted} */
								/>
							}
							label={
								<span className="RegMediumText">
									{i18n.t('searchflow.wantaccounting')}
								</span>
							}
						/>
					</div>
					<div>
						<p className="noprovtitle">
							{i18n.t('searchflow.invoicingdetails')}
						</p>
						{i18n.t('general.noncompany')}
						<Switch
							checked={isCompany}
							onChange={() => {
								setIsCompany(!isCompany);
							}}
						/>
						{i18n.t('general.company')}
						{isCompany ? (
							<>
								<TextField
									style={{ marginTop: '12px' }}
									label={i18n.t('general.obligcompanyname')}
									value={companyLegalName}
									id="companylegalname"
									name="companylegalname"
									onChange={(event) => {
										setCompanyLegalName(event.target.value);
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.value,
												stateObject: 'company_store',
											})
										);
									}}
								/>
								<TextField
									style={{ marginTop: '12px' }}
									label={i18n.t('general.obligaddress')}
									value={legalAddress}
									placeholder="pl.: 1133 Budapest Váci 110"
									id="legaladdress"
									name="legaladdress"
									onChange={(event) => {
										setLegalAddress(event.target.value);
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.value,
												stateObject: 'company_store',
											})
										);
									}}
								/>
								<TextField
									style={{ marginTop: '12px' }}
									label={i18n.t('general.obligtaxnumber')}
									value={companyTaxnumber}
									id="companytaxnumber"
									name="companytaxnumber"
									placeholder="12345678-9-10"
									onChange={(event) => {
										setCompanyTaxnumber(event.target.value);
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.value,
												stateObject: 'company_store',
											})
										);
									}}
									InputProps={{ inputComponent: CleaveInput }}
									InputLabelProps={{
										shrink: true,
									}}
								/>{' '}
							</>
						) : (
							<TextField
								style={{ marginTop: '12px' }}
								label={i18n.t('general.obligaddress')}
								placeholder="pl.: 1133 Budapest Váci 110"
								value={legalAddress}
								id="legaladdress"
								name="legaladdress"
								onChange={(event) => {
									setLegalAddress(event.target.value);
									dispatch(
										ACTIONS.addCompanyInfo({
											id: event.target.id,
											data: event.target.value,
											stateObject: 'company_store',
										})
									);
								}}
							/>
						)}
					</div>
					<div style={{ margin: '12px 0' }}>
						<FormControlLabel
							key={'marketing'}
							control={
								<Checkbox
									id="marketing"
									name="checked"
									checked={companyStore.marketing}
									onChange={(event) => {
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.checked,
												stateObject: 'company_store',
											})
										);
									}}
									color="primary"
									/*    disabled={this.state.submitted} */
								/>
							}
							label={
								<span className="SFSmallText">
									{i18n.t('searchflow.newslettersubtext')}
								</span>
							}
						/>
						<FormControlLabel
							key={'gdpr'}
							control={
								<Checkbox
									id="gdpr"
									name="gdpr"
									checked={companyStore.gdpr}
									onChange={(event) => {
										dispatch(
											ACTIONS.addCompanyInfo({
												id: event.target.id,
												data: event.target.checked,
												stateObject: 'company_store',
											})
										);
									}}
									color="primary"
									required
									/*  disabled={this.state.submitted} */
								/>
							}
							label={gdprLabelSF()}
						/>
					</div>
					{gdprError ? (
						<span
							style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
							{i18n.t('searchflow.plsacceptgdpr')}
						</span>
					) : null}
				</div>
				<div
					className="SFButtonContainer"
					style={{
						justifyContent: 'space-between',
					}}>
					{!isReqSent && (
						<>
							<StyledButton
								className="btnMaxWidth130 Medium "
								color="NewNavBack"
								onClick={() => {
									handleBack();
								}}>
								{i18n.t('general.backbutton')}
							</StyledButton>
							{!submitButtonDisabled() && (
								<StyledButton
									className="btnMaxWidth250 Medium "
									color="NewNavBackWide"
									onClick={() => {
										handleSubmitButton(false);
									}}>
									{i18n.t('general.bookAppointmentWithoutPayment')}
								</StyledButton>
							)}
							<StyledButton
								className="btnMaxWidth250 Medium"
								color="NewNavForwardWide"
								onClick={async () => {
									handleSubmitButton(true);
								}}
								isDisabled={submitButtonDisabled()}>
								{i18n.t('general.paymentAndBooking')}
							</StyledButton>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default withTranslation()(RegContactForm);
